// utils/redux/inventory/inventoryActions.js
import {
    setInventory,
    updateInventoryItem,
    setLoading,
    setError,
    clearError
} from "./inventorySlice";
import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";

// Initialize inventory for a raw material
export const initializeInventoryAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await postMethod('/inventory/initialize', data);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

export const fetchAllInventoryAction = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        // Clean params - remove empty values
        const cleanParams = Object.fromEntries(
            Object.entries(params).filter(([_, value]) =>
                value !== '' && value !== undefined && value !== null
            )
        );

        // Build query string
        const query = new URLSearchParams(cleanParams).toString();
        const url = `/inventory${query ? `?${query}` : ''}`;

        const response = await getMethod(url);

        if (response?.success) {
            // Make sure we have the correct structure
            dispatch(setInventory({
                data: response.data || [],
                pagination: response.pagination || {
                    total: 0,
                    page: 1,
                    pages: 1,
                    limit: 20
                },
                stats: response.stats || {
                    totalItems: 0,
                    totalQuantity: 0,
                    totalValue: 0,
                    lowStockItems: 0,
                    outOfStockItems: 0
                },
                lowStockItems: response.lowStockItems || []
            }));
        }

        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get inventory by raw material ID
export const fetchInventoryByMaterialAction = (rawMaterialId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await getMethod(`/inventory/material/${rawMaterialId}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Update thresholds
export const updateThresholdsAction = (rawMaterialId, data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await putMethod(`/inventory/${rawMaterialId}/thresholds`, data);
        if (response?.success) {
            dispatch(updateInventoryItem(response.data));
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Update location
export const updateLocationAction = (rawMaterialId, data) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await putMethod(`/inventory/${rawMaterialId}/location`, data);
        if (response?.success) {
            dispatch(updateInventoryItem(response.data));
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Get low stock items
export const fetchLowStockItemsAction = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const query = new URLSearchParams(params).toString();
        const response = await getMethod(`/inventory/low-stock?${query}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Delete inventory
export const deleteInventoryAction = (rawMaterialId) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await deleteMethod(`/inventory/${rawMaterialId}`);
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(setError(error.message));
        throw error;
    }
};

// Clear error
export const clearInventoryError = () => (dispatch) => {
    dispatch(clearError());
};